export default __webpack_public_path__ + "static/media/product9.515855b2.webp";